<p-panel header="Filters">
  <ng-template pTemplate="icons">
    <!-- Top Row: Boolean Filters + Add Filters Button -->
    <div class="filters__top-row flex flex-row items-center">
      @if (currentViewMode === 'lotItem') {
        <div class="row-sm-start-center mr-4">
          <p-checkbox
            [(ngModel)]="excludeZeroBalances"
            [binary]="true"
            inputId="excludeZeroBalances"
            (onChange)="onExcludeZeroBalancesChange()"
            [pTooltip]="getTranslation('excludeZeroBalances')"
            tooltipPosition="top"
          />
          <label for="excludeZeroBalances" class="cursor-pointer text-sm whitespace-nowrap">
            {{ getTranslation('excludeZeroBalances') }}
          </label>
        </div>
        <div class="row-sm-start-center mr-4">
          <p-checkbox
            [(ngModel)]="excludeSplitLotItems"
            [binary]="true"
            inputId="excludeSplitLotItems"
            (onChange)="onExcludeSplitLotItemsChange()"
            [pTooltip]="getTranslation('excludeSplitLotItems')"
            tooltipPosition="top"
          />
          <label for="excludeSplitLotItems" class="cursor-pointer text-sm whitespace-nowrap">
            {{ getTranslation('excludeSplitLotItems') }}
          </label>
        </div>
      }

      <!-- Filters Button -->
      <div #miContenedor class="filter__button">
        <p-button
          label="{{ ('Common_Filters' | translate) || 'Filters' }}"
          variant="outlined"
          severity="contrast"
          size="small"
          icon="pi pi-plus"
          (onClick)="menuFiltros.toggle($event)"
        ></p-button>
        <p-menu #menuFiltros [model]="filtersItems" [popup]="true" appendTo="body"></p-menu>
      </div>
    </div>
  </ng-template>

  <p-card>
    <div class="filters col">
      <!-- Second Row: Location + Active Filters -->
      <div class="filters__row">
        <!-- Location TreeSelect -->
        <div class="filter-item">
          <p-floatlabel variant="on" class="cs-floatlabel-fill cs-floatlabel-label-ellipsis">
            <p-treeSelect
              [options]="locationTreeNodes"
              [(ngModel)]="selectedLocationNodes"
              selectionMode="checkbox"
              class="w-full"
              [showClear]="true"
              appendTo="body"
              (onNodeSelect)="onLocationTreeSelectChange($event)"
              (onNodeUnselect)="onLocationTreeSelectChange($event)"
              (onClear)="onLocationTreeSelectChange($event)"
              [filter]="true"
              [pTooltip]="getTooltip('locationsTooltip')"
              tooltipPosition="top"
            >
              <ng-template let-node pTemplate="value">
                @if (selectedLocationNodes && selectedLocationNodes.length > 0) {
                  {{ selectedLocationNodes.length }}
                  {{
                    'Items_Inventory_Locations_Selected'
                      | translateWF
                        : 'location(s)
                selected'
                  }}
                } @else {
                  {{ 'Items_Inventory_Select_Locations' | translateWF: 'Select Locations' }}
                }
              </ng-template>
            </p-treeSelect>
            <label for="locations">{{ getTranslation('locations') }}</label>
          </p-floatlabel>
        </div>

        <!-- Dynamic Filters -->
        <ng-container *ngFor="let customFilter of activeFilters">
          <div class="filter-item" [class.filter-item--wide]="customFilter.name === 'itemCodes'">
            <p-inputgroup>
              <p-inputgroup-addon>
                <p-button icon="pi pi-times" severity="secondary" variant="text" (click)="removeFilter(customFilter)" [pTooltip]="'Remove filter'" tooltipPosition="top" />
              </p-inputgroup-addon>

              <p-floatlabel variant="on" class="cs-floatlabel-fill cs-floatlabel-label-ellipsis">
                <!-- text input -->
                <input pInputText type="text" *ngIf="customFilter.type === 'text'" [pTooltip]="getTooltip(customFilter.name)" tooltipPosition="top" />

                <!-- date input -->
                <p-datepicker
                  *ngIf="customFilter.type === 'date'"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  inputId="icondisplay"
                  appendTo="body"
                  [pTooltip]="getTooltip(customFilter.name)"
                  tooltipPosition="top"
                />

                <!-- select input -->
                <p-select
                  *ngIf="customFilter.type === 'select'"
                  [options]="getFilterOptions(customFilter.name)"
                  appendTo="body"
                  [pTooltip]="getTooltip(customFilter.name)"
                  tooltipPosition="top"
                ></p-select>

                <!-- autocomplete / multiselect -->
                @if (customFilter.type === 'autocomplete') {
                  <p-multiselect
                    [id]="customFilter.name"
                    *ngIf="customFilter.name !== 'manufacturerLotNumbers'"
                    [options]="getFilterOptions(customFilter.name)"
                    [panelStyle]="{ width: customFilter.name === 'itemCodes' ? '450px' : '300px' }"
                    class="w-full"
                    optionLabel="name"
                    optionValue="id"
                    appendTo="body"
                    (onFilter)="searchAutocompleteOptions(customFilter.name, $event)"
                    (onChange)="onAutocompleteChange(customFilter.name, $event)"
                    [pTooltip]="getTooltip(customFilter.name)"
                    tooltipPosition="top"
                  >
                    <ng-template let-option pTemplate="item">
                      <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis" [title]="option.name">
                        {{ option.name }}
                      </div>
                    </ng-template>
                  </p-multiselect>

                  <!-- manufacturerLotNumbers autocomplete with ngModel binding -->
                  @if (customFilter.name === 'manufacturerLotNumbers') {
                    <p-multiselect
                      [id]="customFilter.name"
                      [options]="getFilterOptions(customFilter.name)"
                      [panelStyle]="{ width: '300px' }"
                      [(ngModel)]="selectedProviderLotIds"
                      (onChange)="onAutocompleteChange(customFilter.name, $event)"
                      (onFilter)="searchAutocompleteOptions(customFilter.name, $event)"
                      class="w-full"
                      optionLabel="name"
                      optionValue="id"
                      appendTo="body"
                      [pTooltip]="getTooltip(customFilter.name)"
                      tooltipPosition="top"
                    />
                  }
                }

                <!-- label with selected count -->
                <label [for]="customFilter.name">
                  {{ getTranslation(customFilter.name) }}
                  @if (hasFilterValues(customFilter.name)) {
                    <span class="filter-count">({{ getFilterSelectedCount(customFilter.name) }})</span>
                  }
                </label>
              </p-floatlabel>
            </p-inputgroup>
          </div>
        </ng-container>
      </div>
    </div>
  </p-card>
</p-panel>
